// libraries
import React, { useContext, useState, useEffect } from "react";
import AppButton from "components/app-button";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { AiOutlineClose } from "react-icons/ai";
// commons
import CONSTANSTS from "common/constansts";
import AppCustomToast, { PageContext } from "components/app-custom-toast";

const PageCalendarSettings = () => {
  // const history = useHistory();
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  const week = [
    {
      label: "Monday",
      id: 1,
    },
    {
      label: "Tuesday",
      id: 2,
    },
    {
      label: "Wednesday",
      id: 3,
    },
    {
      label: "Thursday",
      id: 4,
    },
    {
      label: "Friday",
      id: 5,
    },
    {
      label: "Saturday",
      id: 6,
    },
    {
      label: "Sunday",
      id: 0,
    },
  ];

  const initialData = {
    scheduleResponseList: [
      {
        dayOfWeek: "",
        timeSlots: [],
      },
      {
        dayOfWeek: "",
        timeSlots: [],
      },
      {
        dayOfWeek: "",
        timeSlots: [],
      },
      {
        dayOfWeek: "",
        timeSlots: [],
      },
      {
        dayOfWeek: "",
        timeSlots: [],
      },
      {
        dayOfWeek: "",
        timeSlots: [],
      },
      {
        dayOfWeek: "",
        timeSlots: [],
      },
    ],
    latestDayAfter: "",
    maxSlot: "",
    auditTrail: {
      timestamp: "",
      message: null,
      updatedBy: "",
    },
  };
  const initialTimeSlot = {
    result: [""],
  };

  const [days] = useState(week);
  const [meetingSchedule, setMeetingSchedule] = useState(initialData);
  const [timeSlots, setTimeSlots] = useState(initialTimeSlot);

  useEffect(async () => {
    try {
      let token = null;
      token = localStorage.getItem("@storage_token");
      fetch(
        // "http://49.0.203.50/ivc-app/bo/meeting/api/v1/meetingSchedule/find",
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.FIND_MEETING_SCHEDULE,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          if (result !== null || result !== undefined) {
            setMeetingSchedule(result.result);
          } else {
            setMeetingSchedule(meetingSchedule);
          }
        });
      fetch(
        // "http://49.0.203.50/ivc-app/bo/meeting/api/v1/meetingTimeSlot/find",
        process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.FINDALL_MEETING_TIMESLOT,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en", "X-DEVICE-OS": "Web",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          if (result !== null || result !== undefined) {
            setTimeSlots(result.result);
          } else {
            setTimeSlots(initialTimeSlot);
          }
        });
    } catch (e) {
      console.log(e);
    }
  }, []);

  const [showSelectTime, setShowSelectTime] = useState(false);
  const [selectedWhichDay, setselectedWhichDay] = useState(false);
  const selectTimeToggle = () => {
    setShowSelectTime(!showSelectTime);
  };

  //get clicked which button (0~6) total 7 buttons
  const getSelectedDay = (e) => {
    var selected_day = e.target.value;
    setselectedWhichDay(selected_day);
  };

  //show color depend on pulled scheduleRequestList.timSlots
  //change color depend select or unselect
  //remove and add timeSlots
  function SelectTime(values) {
    const time_slot_selection = [];
    var selected_day = selectedWhichDay;
    values.select.map((timeSlot, index) => {
      if (meetingSchedule.scheduleResponseList[selected_day].timeSlots.includes(timeSlot)) {
        time_slot_selection.push(
          <div className="col body__schedule time active m-2" key={index} value={timeSlot} onClick={(e) => changeColor(e)}>
            {timeSlot}
          </div>
        );
      } else {
        time_slot_selection.push(
          <div className="col body__schedule time m-2" key={index} value={timeSlot} onClick={(e) => changeColor(e)}>
            {timeSlot}
          </div>
        );
      }
    });

    return time_slot_selection;
  }

  function removeScheduleTime(e) {
    var selected_time = e.target.getAttribute("value");
    if (meetingSchedule.scheduleResponseList[selectedWhichDay].timeSlots.includes(selected_time)) {
      meetingSchedule.scheduleResponseList[selectedWhichDay].timeSlots = meetingSchedule.scheduleResponseList[selectedWhichDay].timeSlots.filter((timeSlot) => timeSlot !== selected_time);
    }
  }

  function addScheduleTime(e) {
    var selected_time = e.target.getAttribute("value");
    if (!meetingSchedule.scheduleResponseList[selectedWhichDay].timeSlots.includes(selected_time)) {
      meetingSchedule.scheduleResponseList[selectedWhichDay].timeSlots.push(selected_time);
    }
  }

  function changeColor(e) {
    var class_name = e.currentTarget.className;
    var active_class_name = "col body__schedule time active m-2";
    var inactive_class_name = "col body__schedule time m-2";

    if (class_name === inactive_class_name) {
      e.currentTarget.className = active_class_name;
      addScheduleTime(e);
    } else {
      e.currentTarget.className = inactive_class_name;
      removeScheduleTime(e);
    }
  }

  //Handle displaying timeSlots by adding (",") behind each the timeSlot
  function OutputBoxes(values) {
    const output = [];
    var displayData = "";

    var time_slots_arrangement = values.index;

    var length = meetingSchedule.scheduleResponseList[time_slots_arrangement].timeSlots.length - 1;
    meetingSchedule.scheduleResponseList[time_slots_arrangement].timeSlots.map((data, index) => {
      if (index < length) {
        displayData += data + ",";
      } else {
        displayData += data;
      }
    });
    output.push(<div key={values.index}>{displayData}</div>);

    return output;
  }
  //two inputs
  const handleChange = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    value = value.replace(/\D/, "");
    setMeetingSchedule({ ...meetingSchedule, [name]: value });
  };

  const updateMeetingSchedule = async () => {
    var data = {
      latestDayAfter: meetingSchedule.latestDayAfter,
      maxSlot: meetingSchedule.maxSlot,
      scheduleRequestList: meetingSchedule.scheduleResponseList,
    };

    // console.log("Data>>>", JSON.stringify(data));

    let token = null;
    token = localStorage.getItem("@storage_token");
    fetch(
      // "http://49.0.203.50/ivc-app/bo/meeting/api/v1/meetingSchedule/update",
      process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.UPDATE_MEETING_SCHEDULE,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en", "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },

        body: JSON.stringify(data),
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const response = data;
        console.log(response);
        if (response.responseCode === 200) {
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.success, title: CONSTANSTS.DIALOG_TITLE.general_success, message: response.message });
        } else {
          messageDialog({ isOpen: true, condition: CONSTANSTS.DIALOG.failed, title: CONSTANSTS.DIALOG_TITLE.general_failed, message: response.message, defaultOnClick: false });
        }
      });
  };

  return (
    <div className="page-calander-settings">
      <div className="top-context" style={{ padding: "0px 50px 30px 50px" }}>
        <div className="title">Calendar Settings</div>
        <div className="search-button">
          <AppButton
            colorType="orange"
            label="Update"
            onClick={() => {
              updateMeetingSchedule();
            }}
          />
        </div>
      </div>

      <div className="body-context">
        <div className="body-context__container">
          <div className="fields">
            <div>
              {days.map((d) => (
                <div key={d.id} className="app-input-time">
                  <div className="fields">
                    <div className="row-field">
                      <span>{d.label}</span>

                      <OutputBoxes
                        data={meetingSchedule.scheduleResponseList[d.id].timeSlots}
                        index={d.id}
                        // key={d.id}
                      ></OutputBoxes>

                      <button value={d.id} onClick={(e) => [selectTimeToggle(), getSelectedDay(e)]}>
                        Select Time
                      </button>
                    </div>
                  </div>
                </div>
              ))}

              <Modal isOpen={showSelectTime} className="select-time" contentClassName="select-time__content" animation="false">
                <ModalHeader className="header">
                  <AiOutlineClose className="header__close-button" onClick={selectTimeToggle} />
                </ModalHeader>
                <ModalBody className="body">
                  <div className="row row-cols-auto body__schedule">
                    <SelectTime select={timeSlots}></SelectTime>
                  </div>
                </ModalBody>
                <ModalFooter className="footer">
                  <button className="footer__centerButton" onClick={() => [selectTimeToggle(), updateMeetingSchedule()]}>
                    OK
                  </button>
                </ModalFooter>
              </Modal>
            </div>
            <div style={{ paddingTop: "50px", paddingBottom: "50px" }}>
              <div className="bottom-field">
                <div>Latest Date Available</div>
                <input type="text" className="input-number" name="latestDayAfter" value={meetingSchedule.latestDayAfter} onChange={handleChange} maxLength={3} />
              </div>
              <div className="bottom-field">
                <div>Maximum Interview per slot</div>
                <input type="text" className="input-number" name="maxSlot" value={meetingSchedule.maxSlot} onChange={handleChange} maxLength={3} />
              </div>
              <label
                style={{
                  color: "#A28559",
                  float: "right",
                  fontSize: "28px",
                  fontFamily: "gotham-bold",
                }}
              >
                Last Updated by: {meetingSchedule.auditTrail.updatedBy} {meetingSchedule.auditTrail.timestamp}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageCalendarSettings;
